import { FilterCollapse } from 'libs/athos/components/collection/filters/FilterCollapse'
import { useSort } from 'libs/athos/hooks/useSort'

export function FilterSort() {
  const { sorts, activeSort, handleSort, resetSort } = useSort()

  return (
    <FilterCollapse label="Sort By">
      <div className="flex flex-col px-margin pb-1">
        <SortInput
          value="default"
          label="Recommended"
          checked={!activeSort}
          onSelect={resetSort}
        />
        {sorts?.map((sort) => (
          <SortInput
            value={sort.value}
            label={sort.label}
            checked={activeSort === sort.value}
            onSelect={() => handleSort(sort.value)}
            key={sort.value}
          />
        ))}
      </div>
    </FilterCollapse>
  )
}

const SortInput = ({ value, label, checked, onSelect }) => {
  const id = `sort__${value}`

  return (
    <div className="flex w-full cursor-pointer items-center gap-x-0.5 min-h-[44px] py-0.5">
      <input
        id={id}
        className="field-radio shrink-0"
        type="radio"
        name="sort"
        value={value}
        checked={checked}
        onClick={onSelect}
        aria-label={label}
      />
      <label
        for={id}
        className="grow flex cursor-pointer items-center paragraph-s text-type-black-secondary"
      >
        {label}
      </label>
    </div>
  )
}
